import { render, staticRenderFns } from "./otherResumeView.vue?vue&type=template&id=4e6eb70d&scoped=true&"
import script from "./otherResumeView.vue?vue&type=script&lang=js&"
export * from "./otherResumeView.vue?vue&type=script&lang=js&"
import style0 from "./otherResumeView.vue?vue&type=style&index=0&id=4e6eb70d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6eb70d",
  null
  
)

export default component.exports